import apiClient, { safeJson } from '@/api/client';
import { KioskSettingsResponse, UpdateKioskSettingsBody } from './types';

/** 키오스크 설정 조회 */
export const getKioskSettings = async ({ centerId }: { centerId: string }) => {
    const res = await apiClient.get(`v1/centers/${centerId}/kiosk/settings`);
    const data = await safeJson(res);
    return { status: res.status, data: data as KioskSettingsResponse | null };
};

/** 키오스크 설정 수정 */
export const updateKioskSettings = async ({
    centerId,
    body,
}: {
    centerId: string;
    body: UpdateKioskSettingsBody;
}) => {
    const res = await apiClient.put(`v1/centers/${centerId}/kiosk/settings`, { json: body });
    const data = await safeJson(res);
    return { status: res.status, data: data as KioskSettingsResponse | null };
};
